import React from 'react';

// §video-visit (BE #383) — on the confirmation screen, tell the patient their
// doctor visit is by video and that a scheduling link is on its way. Keyed on
// the visit-create RESPONSE, never the checkout choice: the server forces
// video for required types/states, and the dashboard gates on the same
// fields, so the two screens cannot disagree.
//   isSyncVisit            outer gate (union of the two cases below)
//   syncRequired + labs    TRT: the link follows once labs are in
//   visitModality 'video'  the link comes after checkout
// The link itself is never rendered here — booking lives in the patient
// portal (BelugaVisitBanner); the intake must not duplicate it.
export function videoVisitCopy(visitResult) {
  const r = visitResult || {};
  if (r.isSyncVisit !== true) return null;
  if (r.syncRequired === true && r.holdingStatus === 'awaiting_labs') {
    return "We'll send your scheduling link once your labs are in.";
  }
  if (r.visitModality === 'video' || r.syncRequired === true) {
    return "We'll send you a link to pick a time with your doctor.";
  }
  return null;
}

const VideoVisitNote = ({ visitResult, className = 'max-w-xl mx-auto mb-5' }) => {
  const copy = videoVisitCopy(visitResult);
  if (!copy) return null;
  return (
    <div className={`${className} rounded-xl border border-[#2d8a5f]/30 bg-[#f0faf4] p-4 text-sm text-gray-800 text-left`} data-testid="video-visit-note">
      <span className="font-semibold">Your doctor visit is by video.</span> {copy}
    </div>
  );
};

export default VideoVisitNote;
